import {
  buttonSecondaryDark,
  buttonSmall,
  buttonRound,
  buttonIconOnlySmall,
} from "config/buttonStyles";

export const magnificationButtons = {
  display: "flex",
  flexDirection: "row",
  mx: "-6px",
};

export const magnicationButton = {
  ...buttonSecondaryDark,
  ...buttonSmall,
  ...buttonRound,
  ...buttonIconOnlySmall,

  border: "2px solid transparent",
  borderColor: "text",
  p: 0,
  my: 0,
  mx: "6px",
  height: "24px",
  width: "24px",
  minWidth: "24px",
};
